import type { HTMLAttributes, Ref } from 'react';

import { cn } from '@/lib/cn';

export const Skeleton = ({
  className,
  ref,
  ...props
}: HTMLAttributes<HTMLDivElement> & { ref?: Ref<HTMLDivElement> }) => (
  <div ref={ref} className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />
);
Skeleton.displayName = 'Skeleton';
